/**
 * Grafana Faro initialization for frontend observability.
 *
 * Faro sends logs, errors, performance metrics, and session data to
 * Grafana Cloud's Frontend Observability via its own CORS-enabled
 * collector endpoint (unlike the OTLP gateway which blocks browser requests).
 *
 * Environment variables (set via .env / .env.production):
 *   REACT_APP_FARO_URL – Grafana Faro collector URL
 *     e.g. https://faro-collector-prod-us-east-2.grafana.net/collect/<app-key>
 *   REACT_APP_FARO_APP_NAME – application name (default: xquant-frontend)
 *   REACT_APP_FARO_ENABLED – set to "false" to turn the collector off entirely
 */

import {
  initializeFaro,
  getWebInstrumentations,
  faro,
} from '@grafana/faro-react';
const FARO_ENABLED = process.env.REACT_APP_FARO_ENABLED !== 'false';
const FARO_URL = process.env.REACT_APP_FARO_URL || '';
const APP_NAME = process.env.REACT_APP_FARO_APP_NAME || 'xquant-frontend';
const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
const APP_ENV = process.env.NODE_ENV || 'development';

let faroInitialized = false;

export function initFaro() {
  if (faroInitialized) return;
  if (!FARO_ENABLED) {
    console.info('[faro] disabled by REACT_APP_FARO_ENABLED=false');
    return;
  }
  if (!FARO_URL) {
    // Faro not configured — silently skip (local dev without Grafana)
    return;
  }

  try {
    initializeFaro({
      url: FARO_URL,
      app: {
        name: APP_NAME,
        version: APP_VERSION,
        environment: APP_ENV,
      },
      instrumentations: [
        ...getWebInstrumentations(),
      ],
    });
    faroInitialized = true;
  } catch {
    // Graceful degradation — if Faro fails to init, the app still works
  }
}

export { faro };

